module.exports = __webpack_public_path__ + "static/media/sxt.37c25422.png";